// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1WSCr{margin-bottom:1.5rem;font-size:32px;font-weight:500;line-height:40px;font-family:var(--heading-font);letter-spacing:.5px}@media(max-width:767px){._1WSCr{font-size:26px;line-height:32.5px}}._3stC7{font-size:16px;font-weight:300;line-height:26px;font-family:var(--base-font);white-space:pre-line;overflow-wrap:break-word}._2wDXB{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:32px;gap:32px;grid-gap:2rem;gap:2rem}._2wDXB ._24HuW{width:calc(50% - 1rem);display:-ms-flexbox;display:flex;grid-gap:12px;gap:12px;grid-gap:.75rem;gap:.75rem;-ms-flex-align:center;align-items:center}@media(max-width:767px){._2wDXB ._24HuW{width:100%}}._2wDXB ._2SAJ2{width:48px;width:3rem}._2wDXB ._1uiXr{width:calc(100% - 3rem)}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"courseTitle": "_1WSCr",
	"description": "_3stC7",
	"highlightList": "_2wDXB",
	"item": "_24HuW",
	"img": "_2SAJ2",
	"title": "_1uiXr"
};
module.exports = exports;
